import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './styles.styl';

/**
 * Renders a wrapper that uses the BlueprintJS Overlay2 styles/formatting
 * to render a full-height loading overlay. You can pass a message or a
 * spinner.
 */
const LoadingOverlayWrapper: React.FunctionComponent<{
  loading: boolean;
  message?: string;
  children?: React.ReactNode;
  loadingIndicator?: React.ReactNode;
}> = ({loading, message, children, loadingIndicator}) => (
  <div className={cs.loadingContainer}>
    <B.Overlay2
      isOpen={loading}
      className={B.Classes.OVERLAY_CONTAINER}
      usePortal={false}
      hasBackdrop={false}
    >
      <div className={cs.loadingContent}>
        {message}
        {loadingIndicator ?? <B.Spinner size={20} />}
      </div>
    </B.Overlay2>
    {children}
  </div>
);

export default LoadingOverlayWrapper;
